import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=03f2d770&scoped=true"
import script from "@/views/Rooms/Rooms.ts?vue&type=script&lang=ts&external"
export * from "@/views/Rooms/Rooms.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Rooms/rooms.scss?vue&type=style&index=0&id=03f2d770&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f2d770",
  null
  
)

export default component.exports